<ng-container *ngIf="question">
  <div class="grid-builder-wrapper">
    <div class="row gx-4">
      <div class="col-12 col-md-6">
        <div class="title-label mb-2">ROWS</div>
        <ng-container
          *ngFor="
            let rowName of rowNames;
            index as rowIndex;
            trackBy: trackByIndex
          ">
          <div class="d-flex align-items-center mb-2">
            <div class="custom-input-group flex-grow-1">
              <input
                type="text"
                class="form-control custom-input"
                [(ngModel)]="rowNames[rowIndex]"
                (ngModelChange)="onRowNameChange(rowIndex, $event)" />
            </div>
            <button
              *ngIf="rowNames.length > 1"
              class="btn btn-delete fs-13 ms-2"
              type="button"
              aria-label="Delete row"
              (click)="deleteRow(rowIndex)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </ng-container>
        <button
          *ngIf="canAddRow"
          class="btn btn-add-option fw-700 fs-14 p-0 mt-1"
          type="button"
          (click)="addRow()">
          + Add Row
        </button>
        <div *ngIf="!canAddRow" class="fs-12 mt-1 text-muted">
          Maximum of 50 rows reached.
        </div>
      </div>

      <div class="col-12 col-md-6 mt-4 mt-md-0">
        <div class="title-label mb-2">COLUMNS</div>
        <ng-container
          *ngFor="
            let colName of colNames;
            index as colIndex;
            trackBy: trackByIndex
          ">
          <div class="d-flex align-items-center mb-2">
            <div
              class="d-flex align-items-center custom-input-group flex-grow-1">
              <input
                type="text"
                class="form-control custom-input"
                [(ngModel)]="colNames[colIndex]"
                (ngModelChange)="onColNameChange(colIndex, $event)" />
            </div>
            <button
              *ngIf="colNames.length > 1"
              class="btn btn-delete fs-13 ms-2"
              type="button"
              aria-label="Delete column"
              (click)="deleteColumn(colIndex)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </ng-container>
        <button
          *ngIf="canAddColumn"
          class="btn btn-add-option fw-700 fs-14 p-0 mt-1"
          type="button"
          (click)="addColumn()">
          + Add Column
        </button>
        <div *ngIf="!canAddColumn" class="fs-12 mt-1 text-muted">
          Maximum of 10 columns reached.
        </div>
      </div>
    </div>
    <div *ngIf="isQuiz">
      <div class="separator mt-3 mb-4"></div>
      <div class="fw-bold fs-14 mb-2">Mark the correct answers</div>
      <div class="grid-table-container">
        <table class="grid-table">
          <thead>
            <tr>
              <th></th>
              <th *ngFor="let col of serializedFieldTypeSpecs.colNames">
                <div class="mb-3 fw-normal fs-16 mx-3 text-center">
                  {{ col }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of serializedFieldTypeSpecs.rowNames">
              <td>
                <div class="my-2 me-3">{{ row }}</div>
              </td>
              <td *ngFor="let col of serializedFieldTypeSpecs.colNames">
                <div class="d-flex align-items-center justify-content-center">
                  <app-proforms-question-answer-options-checkbox
                    [checkStatus]="getCheckStatus(row, col)"
                    [optionId]="getOptionId(row, col)"
                    (answerClicked)="onAnswerClicked($event)">
                  </app-proforms-question-answer-options-checkbox>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #preview>
  <app-proforms-question-answer-options
    [question]="question"></app-proforms-question-answer-options>
</ng-template>
